import './index.scss'
import logo from '../../Assets/Images/Blind Spot Logo.png'
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons'

const navSlide = () => {
  const burger = document.querySelector(".burger");
  const nav = document.querySelector(".nav-links");
  const navLinks = document.querySelectorAll(".nav-links li");
  
  burger.addEventListener("click", () => {
    
    //Toggle nav
    nav.classList.toggle('nav-active');
    
    //Animate links
    navLinks.forEach((link, index) => {
      if (link.style.animation) {
        link.style.animation = "";
      } else {
        link.style.animation = `navLinkFade 0.5s ease forwards ${index / 7 + 0.3}s`;
      }
    });
    
    //Burger animation
    burger.classList.toggle('toggle')
    
  });
}

navSlide();

const Navbar = () => {
    return(
        <>
        <nav>
    <div class="logo">Nav</div>
    <ul class="nav-links">
    <NavLink exact="true" activeclassName="active" to="/"><li><a href="#">Home</a></li></NavLink>
    <NavLink exact="true" activeclassName="active" to="/product"><li><a href="#">Products</a></li></NavLink>
    <NavLink exact="true" activeclassName="active" to="/contact"> <li><a href="#">Contact</a></li></NavLink>
    <NavLink exact="true" activeclassName="active" to="/login"><FontAwesomeIcon className="navlink" icon={faUser} color='#f0ffff'></FontAwesomeIcon></NavLink>   
    </ul>
    
    <div class="burger">
      <div class="line1"></div>
      <div class="line2"></div>
      <div class="line3"></div>
    </div>
  </nav>
        </>
    )
}

export default Navbar;